module.exports = __webpack_public_path__ + "static/media/map_view.bb3e552a.svg";